import { HStack, Icon, IconNameT, CloseButton, Text, classnames } from '@cad-arc';
import { EventNotificationsCounter } from '../../../event-panel/tabs/components/event-notifications-counter';
import React from 'react';
import { CadNextNotification } from '@mark43/cad-api';
import { observer } from 'mobx-react-lite';

interface EntityItemProps {
    onClick: () => void;
    isPanelFocused: boolean;
    icon: IconNameT;
    entityNumber?: string;
    title: string;
    subtitle?: string;
    allNotifications?: CadNextNotification[];
    onClose?: () => void;
    isPanelAlerting?: boolean;
}

type CSSVars = React.CSSProperties & { [key: `--${string}`]: string };

export const EntityItem = observer((props: EntityItemProps) => {
    return (
        <HStack
            h="40px"
            w="100%"
            borderRadius={3}
            padding={2}
            key={props.entityNumber}
            cursor="pointer"
            onClick={props.onClick}
            className={classnames({'arc-blink-bg': props.isPanelAlerting})}
            bg={props.isPanelFocused ? 'var(--arc-colors-brand-accent) 16%' : undefined}
            justifyContent="space-between"
            style={{
                '--blink-on-bg': 'var(--arc-colors-warning-active)',
                '--blink-on-color': 'var(--arc-colors-raw-black)'
            } as CSSVars}
        >
            <HStack>
                <Icon
                    icon={props.icon}
                    color={props.isPanelFocused && !props.isPanelAlerting ? 'brand.default' : 'inherit'}
                />
                <Text
                    noOfLines={1}
                    fontWeight="bold"
                    style={{
                        color: props.isPanelFocused && !props.isPanelAlerting
                            ? 'var(--arc-colors-brand-default)'
                            : 'inherit',
                    }}
                >
                    {props.title}
                </Text>
                {props.subtitle ? (
                    <Text
                        noOfLines={1}
                        style={{
                            color: props.isPanelFocused && !props.isPanelAlerting
                                ? 'var(--arc-colors-brand-default)'
                                : 'inherit',
                        }}
                    >
                        {props.subtitle}
                    </Text>
                ) : undefined}
                {props.allNotifications ? (
                    <EventNotificationsCounter notifications={props.allNotifications} />
                ) : null}
            </HStack>
            {props.onClose ? <CloseButton onClick={props.onClose} /> : undefined}
        </HStack>
    );
});
